import { useQuery } from '@apollo/client';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import useGraphQLErrorBoundary from 'src/hooks/useGraphQLErrorBoundary';
import { APPOINTMENT_BUNDLES_QUERY } from '../queries/appointmentBundles';
const useAppointmentBundles = options => {
  const personReferenceId = usePersonId();
  const {
    data,
    ...rest
  } = useQuery(APPOINTMENT_BUNDLES_QUERY, {
    ...options,
    variables: {
      personReferenceId,
      ...options.variables
    },
    skip: options.skip || !personReferenceId
  });
  useGraphQLErrorBoundary(rest.error);
  return {
    data: data?.appointmentBundles ?? undefined,
    ...rest
  };
};
export default useAppointmentBundles;